module.exports = __webpack_public_path__ + "img/pic3.8f42aafd.jpg";